export const getSearchParamValue = (search: string, param: string): string => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(param) || '';
};

export const checkIsLocalhost = (): boolean =>
  window.location.hostname === 'localhost';
